// Passion.js
import React from 'react';
import '../passion.css';

function Passion() {
  return (
    <div className="passion-container" id='passion'>
      <h2 className="heading">MY PASSION AS A FRONTEND DEVELOPER</h2>
      <p className="intro">
        Crafting beautiful and interactive user experiences is more than just code—it's an art.
        I breathe life into designs and ensure seamless usability with a touch of creativity and responsiveness.
      </p>

      <div className="tech-stack">
        <h2>Technologies I Love Working With</h2>
        <div className="icons">
          <div className="icon html">HTML</div>
          <div className="icon css">CSS</div>
          <div className="icon js">JavaScript</div>
          <div className="icon react">React</div>
          <div className="icon tailwind">Tailwind</div>
          <div className="icon tailwind">Bootstrap</div>
          <div className="icon git">Git & GitHub</div>
          <div className="icon git">Node.js</div>
          <div className="icon git">Express.js</div>
          <div className="icon git">MongoDB</div>
        </div>
      </div>

      <div className="quote">
        <p>“Code is not just logic — it's a canvas for imagination.”</p>
      </div>
      <br /><br /><hr />
    </div>
  );
}

export default Passion;
